<template>

<app-panel v-on:close="$emit('close')">
		
	<app-panel-title text="Input" />

	<app-panel-content class="panel-form">

		<app-input-select :disabled="model.automated" label="Type" placeholder="Select type" :stacked="true" v-model="model.type" :validation="$v.model.type" :options="typeOptions" />
		<app-input-text v-if="hasName" label="Name" placeholder="Enter name" notes="For internal reference only."  :stacked="true" v-model="model.name" :validation="$v.model.name" />
		<app-input-text v-if="hasLabel" label="Label" placeholder="Enter label" notes="What the user will see next to the input." :stacked="true" v-model="model.label" :validation="$v.model.label" />
		<app-input-text v-if="hasText" label="Text" placeholder="Enter text" :stacked="true" v-model="model.label" :validation="$v.model.label" />
		<app-input-text v-if="hasPlaceholder" label="Placeholder" placeholder="Enter placeholder" notes="What the user will see before they enter text." :stacked="true" v-model="model.placeholder" :validation="$v.model.placeholder" />
		<app-input-text v-if="hasDescription" label="Description" :autogrow="true" placeholder="Enter description" notes="What the user will see underneath the input" :stacked="true" v-model="model.description" :validation="$v.model.description" />
		<app-input-select v-if="isEvent" label="Max Suggestions" placeholder="Select maximum" notes="Allow user to add additional suggested events up to a maximum" :stacked="true" v-model="model.events" :validation="$v.model.events" :options="eventsOptions" />
		<app-input-select v-if="isEvent" label="Preferred Times" placeholder="Select type" notes="Require the user to give a specific number of preferred times for an event" :stacked="true" v-model="model.times" :validation="$v.model.times" :options="timesOptions" />
		<app-input-select v-if="isEvent" label="Room" placeholder="Select room" notes="The room that the event suggestion will be attached to." :stacked="true" v-model="model.room" :validation="$v.model.room" :options="roomOptions" />
		<app-input-toggle v-if="hasRequired" :disabled="model.automated" label="Required" :stacked="true" :row="true" :full-width="true" v-model="model.required" :validation="$v.model.required" />
		<app-input-select v-if="allowedRoleOptions.length" :disabled="model.automated" label="Role" :allowDeselect="true" placeholder="Select role" notes="Does this input perform a functional role." :stacked="true" v-model="model.role" :validation="$v.model.role" :options="allowedRoleOptions" />
		<app-input-select v-if="hasValidation" :disabled="model.automated" :allowDeselect="true" label="Validation" placeholder="Select validation" :stacked="true" v-model="model.validation" :validation="$v.model.validation" :options="allowedValidationOptions" />
		
		<app-input-options v-if="hasOptions" :stacked="true" placeholder="Add options..." label="Options" v-model="model.options" :validation="$v.model.options" />
		
	</app-panel-content>

	<app-panel-content :space="true">

		<app-button text="Confirm" :disabled="$v.invalid" v-on:click="$emit('save', model)" />

	</app-panel-content>

</app-panel>

</template>

<script>

import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Vue from 'vue'
import deepmerge from 'deepmerge'

export default {

	mixins: [validationMixin],

	props: ['item', 'usedRoles', 'options'],

	data: function() {

		return {
			model: {
				name: '',
				type: 0,
				label: '',
				required: 0,
				validation: 0,
				room: '',
				placeholder: '',
				description: '',
				role: 0,
				options: [],
				automated: false,
				times: 1,
				events: 1
			},
			eventsOptions: [
				{ value: 1, text: '1 suggestion' },
				{ value: 2, text: '2 suggestions' },
				{ value: 3, text: '3 suggestions' },
				{ value: 4, text: '4 suggestions' },
				{ value: 5, text: '5 suggestions' }
			],
			timesOptions: [
				{ value: 1, text: '1 time' },
				{ value: 2, text: '2 times' },
				{ value: 3, text: '3 times' },
				{ value: 4, text: '4 times' },
				{ value: 5, text: '5 times' }
			],
			roleOptions: [
				{ value: 1, text: 'First name' },
				{ value: 2, text: 'Last name' },
				{ value: 3, text: 'E-mail' }
			],
			typeOptions: [
				{ value: 1, text: 'Textbox' },
				{ value: 2, text: 'Toggle' },
				{ value: 3, text: 'Select' },
				{ value: 4, text: 'Checklist' },
				{ value: 8, text: 'Event Suggestion'}
			],
			validationOptions: [
				{ value: 1, text: 'Valid Email Address' },
				{ value: 3, text: 'Unique Badge Email' }
			],
			roomOptions: []
		}

	},

	validations: {
		model: {
			name: {
				required
			}
		}
	},

	watch: {
	
		label: function(n) {
			
			if (this.hasText) this.model.name = n
		
		}

	},

	created: function() {

		if (this.$_.isObject(this.item)) Vue.set(this, 'model', deepmerge(this.model, this.item))
		
		if (!this.model.id) this.model.id = this.$util.generateKey()

		if (this.isEvent) {
		
			this.$api.post('suggest/convention/schedule/room').then(function(json) {
			
				this.roomOptions = json.suggestions
			
			}.bind(this))

		}

	},

	computed: {

		label: function() {
		
			return this.model.label

		},

		allowedValidationOptions: function() {

			if (this.options.validation) {

				return this.$_.filter(this.validationOptions, function(validation) {

					return this.$_.contains(this.options.validation, validation.value) 

				}.bind(this))

			} else {

				return this.validationOptions

			}

		},

		allowedRoleOptions: function() {

			return this.$_.filter(this.roleOptions, function(role) {

				return !this.$_.contains(this.usedRoles, role.value) || role.value === this.item.role

			}.bind(this))

		},

		hasOptions: function() {

			return this.$_.contains([
				this.$constants.registration.input.type.toggle,
				this.$constants.registration.input.type.select,
				this.$constants.registration.input.type.checklist
			], this.model.type)

		},

		hasValidation: function() {

			return this.$_.contains([
				this.$constants.registration.input.type.textbox
			], this.model.type) && this.allowedValidationOptions.length

		},

		hasPlaceholder: function() {

			return this.$_.contains([
				this.$constants.registration.input.type.select,
				this.$constants.registration.input.type.textbox,
				this.$constants.registration.input.type.game
			], this.model.type)

		},

		hasRequired: function() {

			return !this.$_.contains([
				this.$constants.registration.input.type.subheading
			], this.model.type)

		},

		isEvent: function() {

			return this.$_.contains([
				this.$constants.registration.input.type.event
			], this.model.type)

		},

		hasName: function() {

			return !this.$_.contains([
				this.$constants.registration.input.type.subheading
			], this.model.type)

		},

		hasLabel: function() {

			return !this.$_.contains([
				this.$constants.registration.input.type.subheading
			], this.model.type)

		},

		hasText: function() {

			return this.$_.contains([
				this.$constants.registration.input.type.subheading
			], this.model.type)

		},

		hasDescription: function() {

			return !this.$_.contains([
				this.$constants.registration.input.type.subheading,
				this.$constants.registration.input.type.event
			], this.model.type)

		}

	}

}

</script>

<style scoped>

.panel-form >>> .input-notes {
	color: #fff!important;
}

</style>
